<template>
  <v-hover>
    <template v-slot:default="{ hover }" width="50%">
      <article class="mt-5">
        <v-img
          class="white--text px-4 py-4 img-thumbnail"
          :src="module.thumbnail_display"
          gradient="to top right, rgba(0,0,0,.70), rgba(25,32,72,.7)"
          cover
          aspect-ratio="1.778"
        >
          <!-- <v-fade-transition v-if="isEdit">
            <v-overlay v-if="hover" absolute color="#000">
              <div
                class="d-flex flex-wrap justify-content-center justify-content-md-end w-100"
              >
                <v-btn color="#fff" small @click="toggleEditModuleDialog"
                  >Edit Module</v-btn
                >
                &nbsp;
                <v-btn color="#ff5252" small @click="deleteItem(module)"
                  >Delete Module</v-btn
                >
              </div>
            </v-overlay>
          </v-fade-transition> -->
          <v-expand-transition>
            <div
              v-if="hover"
              class="text-center transition-fast-in-fast-out darken-2 v-card--reveal text-h2 white--text"
              style="height: 35%"
            >
              <div class="d-block">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click="goToModules(module.id)"
                      rounded
                      class="primaryMainText--text"
                      color="primaryMain"
                    >
                      Start Learning
                      <v-icon class="ml-2" small>fal fa-arrow-right</v-icon>
                    </v-btn>
                  </template>
                  <span>Proceed to Module</span>
                </v-tooltip>
              </div>
              <div v-if="isEdit" class="d-block mt-2 mb-2">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-btn
                      @click="toggleEditModuleDialog"
                      color="#555555"
                      x-small
                      v-on="on"
                      dark
                      depressed
                      rounded
                      class="mr-2"
                    >
                      <v-icon small>fal fa-edit</v-icon>
                      Edit
                    </v-btn>
                  </template>
                  <span>Edit Module</span>
                </v-tooltip>
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-btn
                      @click="deleteItem(module)"
                      color="red"
                      x-small
                      v-on="on"
                      dark
                      depressed
                      rounded
                    >
                      <v-icon small>fal fa-trash</v-icon>
                      Delete
                    </v-btn>
                  </template>
                  <span>Delete Module</span>
                </v-tooltip>
              </div>
            </div>
          </v-expand-transition>
          <section class="d-flex flex-row justify-content-between mt-1">
            <div>
              <h4 class="font-bold text-white" v-text="module.name"></h4>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span class="subtitle-1" v-on="on" v-bind="attrs">
                    Module
                  </span>
                </template>
                <span>A module is consist of multiple videos and series</span>
              </v-tooltip>
            </div>
            <v-tooltip top>
              <template #activator="{ on }">
                <div v-on="on" class="">
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        text
                        x-small
                        color="primaryMain"
                        class="buttonBorder py-1 px-3 mb-2"
                      >
                        <i class="fas fa-bars fa-1x text-webinarinc"></i>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              class="white--text"
                              @click.stop="showShareModule = true"
                              text
                              x-small
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon right dark class="mr-2"
                                >fal fa-share-alt</v-icon
                              >
                              Share Module
                              <share-module
                                :module_id="module.id"
                                v-model="showShareModule"
                              />
                            </v-btn>
                          </template>
                          <span> Share the whole module to your team. </span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              class="white--text"
                              @click.stop="showAssignModule = true"
                              text
                              x-small
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon right dark class="mr-2"
                                >fal fa-users</v-icon
                              >
                              Assign Module
                              <assign-module
                                :module_id="module.id"
                                v-model="showAssignModule"
                              />
                            </v-btn>
                          </template>
                          <span> Assign the whole module to your team. </span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-btn
                          color="primary"
                          class="white--text"
                          @click="togglePreviewUnfinishedUnitsDialog"
                          text
                          x-small
                        >
                          <v-icon right dark class="mr-2">fal fa-eye</v-icon>
                          View Unfinished Units
                        </v-btn>
                      </v-list-item>
                      <v-list-item>
                        <v-btn
                          color="primary"
                          class="white--text"
                          @click="goToModules(module.id)"
                          text
                          x-small
                        >
                          <v-icon right dark class="mr-2"
                            >fal fa-arrow-right</v-icon
                          >
                          Proceed to Module
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
              <span>More Actions...</span>
            </v-tooltip>
          </section>
          <section
            class="d-flex flex-row justify-content-between mt-1"
            style="position: relative; z-index: 10"
          >
            <div class="row text-center">
              <div class="col" style="border-right: 1px solid #fff">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <span
                      v-on="on"
                      class="text-white interactive"
                      @click="togglePreviewSeriesDialog"
                      ><strong style="color: var(--primary-text)">{{
                        module.details.series_count
                      }}</strong
                      ><br />
                      Series</span
                    >
                  </template>
                  <span>Click to Preview</span>
                </v-tooltip>
              </div>
              <div class="col" style="border-right: 1px solid #fff">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <span
                      v-on="on"
                      class="text-white interactive"
                      @click="togglePreviewUnitsDialog"
                      ><strong style="color: var(--primary-text)">{{
                        module.details.units_count
                      }}</strong
                      ><br />
                      Unit(s)</span
                    >
                  </template>
                  <span>Click to Preview</span>
                </v-tooltip>
              </div>
              <div class="col">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <span v-on="on" class="text-white"
                      ><strong style="color: var(--primary-text)">{{
                        module.details.duration
                      }}</strong></span
                    >
                  </template>
                  <span
                    >Total Duration of
                    {{ module.details.units_count }} Units</span
                  >
                </v-tooltip>
              </div>
            </div>
          </section>
          <section
            class="interactive floating-el"
            @click="goToModules(module.id)"
          ></section>
          <section
            class=""
            style="position: absolute; width: 93%; bottom: 10px"
          ></section>
        </v-img>
        <preview-dialog
          :module-id="module.id"
          :series="module.preview.series"
          :preview-series-dialog="previewSeriesDialog"
          :toggle-preview-dialog="closeAll"
          :is-module-page="true"
        />
        <preview-units-dialog
          :module-id="module.id"
          :units="combinedUnits"
          :preview-unit-dialog="previewUnitsDialog"
          :toggle-preview-dialog="closeAll"
          :is-module-page="true"
        />
        <preview-units-dialog
          :module-id="module.id"
          :units="unitProgress.outstandingUnits"
          :preview-unit-dialog="previewUnfinishedUnitsDialog"
          :toggle-preview-dialog="closeAll"
          :is-module-page="true"
        />
        <preview-progress-dialog
          :module-id="module.id"
          :progress="unitProgress"
          :preview-progress-dialog="previewProgressDialog"
          :toggle-preview-progress-dialog="closeAll"
          :is-module-page="true"
        />
        <edit-module-dialog
          :module="module"
          :edit-module-dialog="editModuleDialog"
          :toggle-edit-module-dialog="toggleEditModuleDialog"
          v-on:close-dialog="closeDialog"
          v-on:module="getModule"
          :show-curriculum="showCurriculum"
        ></edit-module-dialog>
        <confirm-delete-dialog
          :close-dialog="closeConfirmDialog"
          :confirm-action="proceedToDelete"
          :unpublished-action="proceedToDelete"
          :show-dialog="showConfirmDeleteDialog"
          :loading="loading.delete"
        >
          Are you sure you want to proceed?
        </confirm-delete-dialog>
      </article>
    </template>
  </v-hover>
</template>

<script>
import { map as _map, each as _each, filter } from 'lodash-es';
import PreviewDialog from '@/components/course-certification/includes/PreviewSeriesDialog';
import PreviewUnitsDialog from '@/components/course-certification/includes/PreviewUnitsDialog';
import PreviewProgressDialog from '@/components/course-certification/includes/PreviewProgressDialog';
import AssignModule from '@/components/client-lms/dialog-box/AssignModule';
import ShareModule from '@/components/client-lms/dialog-box/ShareModule';
import EditModuleDialog from '@/components/course-certification/includes/EditModuleDialog';
import ConfirmDeleteDialog from '@/components/dialogs/ConfirmDeleteDialog';

export default {
  name: 'ModuleCard',
  components: {
    PreviewDialog,
    PreviewUnitsDialog,
    PreviewProgressDialog,
    AssignModule,
    ShareModule,
    EditModuleDialog,
    ConfirmDeleteDialog,
  },
  props: {
    isEdit: Boolean,
    module: {
      type: Object,
    },
  },
  data() {
    return {
      previewSeriesDialog: false,
      previewUnitsDialog: false,
      previewUnfinishedUnitsDialog: false,
      previewProgressDialog: false,
      showAssignModule: false,
      showShareModule: false,
      editModuleDialog: false,
      combinedUnits: [],
      selectedIdForDeletion: '',
      selectedForDeletion: '',
      loading: {
        delete: false,
      },
      showConfirmDeleteDialog: false,
      showCurriculum: false,
    };
  },
  created() {
    _each(this.module.preview.series, (data) => {
      _each(data.units, (units) => {
        this.combinedUnits.push(units);
      });
    });
    if (this.users.length <= 0) {
      this.fetchUsers();
    }
    this.editModuleDialog = false;
  },
  computed: {
    users() {
      return this.$store.state.lmsClient.listUsers;
    },
    checkProgressChange() {
      return this.module.isCertified && this.module.completed_percentage < 100;
    },
    unitProgress() {
      let completedUnits = this.combinedUnits.filter((unit) => {
        return unit.unit.is_completed;
      });

      let watchedUnits = this.combinedUnits.filter((unit) => {
        return unit.unit.is_finished_watching && !unit.unit.is_completed;
      });

      let outstandingUnits = this.combinedUnits.filter((unit) => {
        return !unit.unit.is_finished_watching && !unit.unit.is_completed;
      });

      return {
        totalCount: this.combinedUnits.length,
        completedUnits: completedUnits,
        watchedUnits: watchedUnits,
        outstandingUnits: outstandingUnits,
      };
    },
    courseCardStyle() {
      return {
        backgroundImage: `url('${this.module.thumbnail}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
      };
    },
  },
  methods: {
    fetchUsers() {
      this.$store
        .dispatch('lmsClient/fetchUsersByDealer')
        .then(({ data }) => {
          this.$store.dispatch('lmsClient/setUsers', data);
        })
        .catch(() => {
          console.log('error');
        });
    },
    togglePreviewSeriesDialog() {
      this.previewSeriesDialog = !this.previewSeriesDialog;
    },
    togglePreviewUnfinishedUnitsDialog() {
      this.previewUnfinishedUnitsDialog = !this.previewUnfinishedUnitsDialog;
    },
    togglePreviewProgressDialog() {
      this.previewProgressDialog = !this.previewProgressDialog;
    },
    togglePreviewUnitsDialog() {
      this.previewUnitsDialog = !this.previewUnitsDialog;
    },
    toggleEditModuleDialog() {
      this.editModuleDialog = !this.editModuleDialog;
    },
    goToModules(id) {
      this.$router.push({
        name: 'CertificationModulePage',
        params: {
          id,
        },
      });
    },
    closeAll() {
      this.previewSeriesDialog = false;
      this.previewUnitsDialog = false;
      this.previewUnfinishedUnitsDialog = false;
      this.previewProgressDialog = false;
      this.editModuleDialog = false;
    },
    closeDialog() {
      this.editModuleDialog = false;
    },
    proceedToDelete() {
      this.loading.delete = true;
      this.$store
        .dispatch('modules/deleteModule', this.selectedIdForDeletion)
        .then(() => {
          this.$notify('success', 'Module removed!');
          this.$emit('deletedModule', this.module);
          this.closeConfirmDialog();
        });
    },
    deleteItem(item) {
      this.selectedIdForDeletion = item.id;
      this.selectedForDeletion = item;
      this.showConfirmDeleteDialog = true;
    },
    closeConfirmDialog() {
      this.showConfirmDeleteDialog = false;
      this.loading.delete = false;
    },
    getModule(item) {
      this.$emit('module', item);
    },
  },
};
</script>
<style lang="stylus" scoped>
.buttonBorder {
  border: 1px solid var(--primary)
}
.text-webinarinc {
  color: var(--primary)
}
.border-r-1 {
  border-right: 1px solid white
}
.pulsing:hover, .pulsing-active {
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  animation: pulse-black 1.2s infinite;
}
/* Animation */
@keyframes pulse-black {
  0% {
    box-shadow: 0 0 0 0 rgba(249, 180, 23 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(249, 180, 23 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(249, 180, 23 0);
  }
}
.interactive {
  cursor: pointer;
}
.floating-el {
  width:100%;
  height: 100%;
  text-align: center !important;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
</style>
